export const blockIconsSocialSchool = (
	<span className='material-symbols-outlined'>school</span>
);
